// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__8ZrRi","button":"Stepper_button__7_ff9","input":"Stepper_input__YqR82"};